import { type ChatMessageModel } from '@/shared/api'

import {
  ChatMessageTypeEnum,
  type GroupMessageItem,
  GroupMessageType,
} from './feedbacks-type'

export function groupMessagesBySeparators(
  messages: ChatMessageModel[],
  options: { withUnread?: boolean } = {},
) {
  const { withUnread = true } = options
  const result: Array<GroupMessageItem> = []
  let lastDate: string | null = null
  let unreadPushed = false

  for (let i = messages.length - 1; i >= 0; i--) {
    const item = messages[i]
    const prevItem = i + 1 < messages.length ? messages[i + 1] : null

    if (
      withUnread &&
      !unreadPushed &&
      !item.isCurrentUserMessage &&
      !item.isRead &&
      (!prevItem || prevItem.isRead)
    ) {
      unreadPushed = true
      result.push({ type: GroupMessageType.UNREAD })
    }

    const msgDate = new Date(item.date)
    const dateStr = msgDate.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    })

    if (lastDate !== dateStr && i > 1) {
      result.push({ type: GroupMessageType.DATE, date: dateStr })
      lastDate = dateStr
    }

    if (item.type === ChatMessageTypeEnum.UsersMessage) {
      result.push({ type: GroupMessageType.USER_MESSAGE, item })
    } else if (item.type === ChatMessageTypeEnum.SystemMessage) {
      result.push({ type: GroupMessageType.SYSTEM_MESSAGE, item })
    }
  }

  return result
}
